import { ICreateEventoUseCase } from "../../../presentation/useCases/create/create_evento_use_case";
import { IRhRepository } from "../../repositories/rh_repository";

/**
 * CreateEventoUseCase
 */

export class CreateEventoUseCase implements ICreateEventoUseCase {
  constructor(
    private readonly repository: IRhRepository,
  ) { }

  async createEvento(
    idFuncionario: number,
    idItemVerba: number,
    valor: number,
    descricao: string | null,
  ): Promise<void> {
    await this.repository.createEvento(
      idFuncionario,
      idItemVerba,
      valor,
      descricao,
    );
  }
}